import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UsersThree, ArrowRight, X } from 'phosphor-react';

const SupportCircleOnboarding = ({ onComplete, onSkip }) => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 bg-stone-900/50 backdrop-blur-sm z-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-3xl p-8 max-w-lg w-full shadow-soft relative">
        <button
          onClick={onSkip}
          className="absolute top-6 right-6 text-stone-400 hover:text-stone-600 transition-colors"
          data-testid="skip-onboarding-btn"
        >
          <X size={24} />
        </button>

        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
            <UsersThree size={32} weight="duotone" className="text-primary" />
          </div>
          <h2 className="text-2xl font-serif font-semibold text-stone-800 mb-3">
            You're Not Alone
          </h2>
          <p className="text-stone-600 leading-relaxed">
            Before we begin, let's make sure you're not alone outside this space.
          </p>
        </div>

        <div className="bg-stone-50 rounded-2xl p-6 mb-6 space-y-3 text-sm text-stone-700">
          <p className="flex items-start gap-2">
            <span className="text-primary">•</span>
            <span>Trusted contacts are completely optional</span>
          </p>
          <p className="flex items-start gap-2">
            <span className="text-primary">•</span>
            <span>They only receive messages with your consent</span>
          </p>
          <p className="flex items-start gap-2">
            <span className="text-primary">•</span>
            <span>No private information is ever shared</span>
          </p>
          <p className="flex items-start gap-2">
            <span className="text-primary">•</span>
            <span>You can add support people anytime in Safety settings</span>
          </p>
        </div>

        <button
          onClick={() => {
            onComplete();
            navigate('/safety');
          }}
          className="w-full bg-primary text-white rounded-full px-8 py-4 font-medium hover:shadow-soft transition-all duration-300 active:scale-95 flex items-center justify-center gap-2 mb-3"
          data-testid="setup-support-circle-btn"
        >
          Set Up Support Circle
          <ArrowRight size={20} weight="bold" />
        </button>

        <button
          onClick={onSkip}
          className="w-full text-stone-500 hover:text-stone-700 text-sm transition-colors"
          data-testid="skip-for-now-btn"
        >
          Skip for now
        </button>
      </div>
    </div>
  );
};

export default SupportCircleOnboarding;
